<template>
  <div class="paragraph" :class="`${background}-background`">
    <h2 class="paragraph__title" v-html="title" />
    <div class="paragraph__text" v-html="text" />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    background: {
      type: String,
    },
  },
}
</script>

<style lang="less" scoped>
.paragraph {
  .paragraph__title {
    font-weight: var(--ds-weight-semi-bold);
    font-size: 26px;

    :deep(strong) {
      color: var(--ds-color-primary-100);
    }
  }

  @media @bp-desktop {
    .paragraph__title {
      font-size: 32px;
    }
    .paragraph__text {
      font-weight: 400;
      font-size: var(--ds-font-md);
      white-space: pre-wrap;
    }
  }
}

.secondary-background {
  border-radius: 8px;
  padding: 28px 24px;
  background-color: var(--ds-color-primary-25);
}

.primary-background {
  border-radius: 8px;
  padding: 28px 24px;
  background-color: var(--ds-color-primary-25);
}
</style>
